<template>
<div class="chapter">
<div class="inner_page">
<p class="part_num"><span epub:type="pagebreak" id="page11" title="11"></span><a href="#/Text/Contents#p1"><span class="blue">Part I</span></a></p>
<p class="part_ttl"><span epub:type="pagebreak" id="page12" title="12"></span><a href="#/Text/Contents#p1"><span class="blue">Let’s Make the Most of This Beautiful Day</span></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part001.vue?b0a55668